<template src='./new.pug' lang="pug"></template>

<script>
import _ from 'underscore'
import vSelect from 'vue-select'
import { VueTabs, VTab } from 'vue-nav-tabs'
import { TheMask } from 'vue-the-mask'
import PageTitle from '../../../layout/pageTitle/PageTitle'
import DynamicInput from '../../../input/dynamicInput/DynamicInput'
import ButtonPrimary from '../../../buttons/buttonPrimary/ButtonPrimary'
import customSorter from '../../../../utils/customSorter.js'
import customValidator from '../../../../utils/customValidator.js'
import looseDeepEqual from '../../../../utils/looseDeepEqual'
import PATHS from '../../../../router/routesMap.js'

export default {
  name: 'EstablishmentsNew',

  components: {
    vSelect,
    VueTabs,
    VTab,
    TheMask,
    PageTitle,
    DynamicInput,
    ButtonPrimary
  },

  data () {
    return {
      requestSent: false,
      editFirstCity: true,
      establishment: {
        id: null,
        nome: null,
        nomeFantasia: null,
        cnpj: null,
        uf: null,
        cidade: {
          nome: '',
          sigla: ''
        },
        grupo: null,
        situacao: null
      },
      uf: [],
      cities: [],
      establishmentsGroup: [],
      inputEstabelecimentoValidator: false,
      tabMain: '',
      dynamicValidator: true,
      attributesList: [],
      attributesLoaded: false
    }
  },

  computed: {
    establishmentsGroupList () {
      return _.sortBy(this.establishmentsGroup, function (item) {
        return customSorter.cleanLowerString(item.nome)
      }, 'asc')
    },
    establishmentGroupInput () {
      return this.establishment.grupo
    },

    tabEstab () {
      return this.$store.getters.establishmentToEditId ? this.$t('estabelecimentos.labels.editarEstabelecimento')
        : this.$t('estabelecimentos.labels.novoEstabelecimento')
    },

    tabAtt () {
      return this.$t('estabelecimentos.labels.estabbelecimentoAtributos')
    },

    stylizeGroupLabel () {
      return (option) => {
        let result = null
        if (typeof option === 'object') {
          if (this.label && option[this.label]) {
            result = option[this.label]
          } else {
            result = option['nome']
          }
        } else {
          result = option + ' (' + this.$t('inputTag.labels.novo') + ')'
        }
        return result
      }
    }
  },

  watch: {
    establishmentGroupInput () {
      if (this.establishment.grupo && !this.establishment.grupo.nome) {
        this.establishment.grupo = {nome: this.establishment.grupo}
      }
      if (this.establishment.grupo && this.establishment.grupo.nome && this.establishment.grupo.nome.length > 20) {
        this.establishment.grupo.nome = this.establishment.grupo.nome.slice(0, 20)
        this.inputEstabelecimentoValidator = true
      } else {
        this.establishment.grupo.nome = this.establishment.grupo.nome
        this.inputEstabelecimentoValidator = false
      }
    },
    establishment: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.establishment, attributes: this.attributesList }, ['invalid']))
      },
      deep: true
    },
    attributesList: {
      handler () {
        this.$store.dispatch('setHasUnsavedChanges', !looseDeepEqual(this.defaultObject, { ...this.establishment, attributes: this.attributesList }, ['invalid']))
      },
      deep: true
    }
  },

  methods: {
    setIsInvalid (att, isInvalid) {
      att.invalid = isInvalid
    },

    loadEstablishmentAtt () {
      const self = this
      let url = '/establishment/loadEstablishmentAtt'
      self.$store.dispatch('loadEstablishmentAtt', url)
        .then((response) => {
          self.attributesList = response
          if (self.$store.getters.establishmentToEditId) {
            self.loadEstablishment()
          } else {
            self.attributesLoaded = true
            self.defaultObject = { ...self.establishment, attributes: [...self.attributesList.map(att => ({ ...att }))] }
          }
        })
        .catch((error) => {
          let notifTitle = self.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar'
          self.$root.$refs.notification.error(error.message, notifTitle)
        }
      )
    },

    newEstablishment () {
      this.establishment.atributosValores = this.attributesList
        .map(att => {
          att.idAtributoCfg = att.atributoCfg ? att.atributoCfg.id : null
          att.idVinculo = this.establishment.id ? this.establishment.id : null
          if (!att.valorOriginal || att.tipo !== 'DATE') {
            att.valor = att.valorOriginal
            if (att.tipo === 'COMBO') {
              att.valor = att.valorOriginal ? att.valorOriginal.valor : null
            }
            return att
          }

          if (!(att.valorOriginal instanceof Date)) {
            att.valorOriginal = new Date(att.valorOriginal)
          }
          const [
            day,
            month,
            year
          ] = [
            att.valorOriginal.getDate().toString().padStart(2, '0'),
            (att.valorOriginal.getMonth() + 1).toString().padStart(2, '0'),
            att.valorOriginal.getFullYear().toString()
          ]
          att.valor = `${year}/${month}/${day}`
          return att
        })

      this.requestSent = true
      this.$store.dispatch('newEstablishment', this.establishment)
        .then((response) => {
          if (this.establishment.id) {
            this.$root.$refs.notification.success('estabelecimentos.sucesso.editado')
          } else {
            this.$root.$refs.notification.success('estabelecimentos.sucesso.criado')
          }
          this.$store.dispatch('setHasUnsavedChanges', false)
          this.$router.push(PATHS.LIST_ESTABLISHMENTS)
        })
        .catch((error) => {
          let notifTitle = this.establishment.id ? 'estabelecimentos.erro.editar' : 'estabelecimentos.erro.criar'
          this.$root.$refs.notification.error(error.message || '', notifTitle)
        })
        .finally(() => {
          this.requestSent = false
        })
    },

    loadEstablishment () {
      const self = this
      self.$store.dispatch('getEstablishment', self.$store.getters.establishmentToEditId)
        .then((response) => {
          self.establishment = response
          self.attributesList = self.attributesList.map(existingAttribute => {
            existingAttribute.invalid = false
            const insertedAttribute = self.establishment.atributosValores.find(att => att.nomeAtributo === existingAttribute.nomeAtributo)
            if (!insertedAttribute) {
              return existingAttribute
            }
            existingAttribute.valorOriginal = insertedAttribute.valor
            if (existingAttribute.tipo === 'DATE') {
              existingAttribute.valorOriginal = new Date(insertedAttribute.valor)
            }
            if (existingAttribute.tipo === 'COMBO') {
              existingAttribute.valorOriginal = {
                valor: insertedAttribute.valor
              }
            }
            return existingAttribute
          })
          self.attributesLoaded = true
          self.defaultObject = { ...self.establishment, attributes: [...self.attributesList.map(att => ({ ...att }))] }
        })
        .catch((error) => {
          self.$root.$refs.notification.error(error.message)
        })
    },

    loadEstablishmentGroups () {
      this.$store.dispatch('getEstablishmentGroups')
        .then((response) => {
          this.establishmentsGroup = response
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error.message)
        })
    },

    loadUfs () {
      this.$store.dispatch('getStates')
        .then(response => {
          this.uf = response
          this.loadCities()
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    loadCities () {
      this.$store.dispatch('getCities', this.establishment.uf)
        .then(response => {
          this.cities = response
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    updateCities (vSelectValue) {
      if (this.editFirstCity) {
        this.establishment.cidade = null
      }
      this.establishment.uf = vSelectValue
      this.$store.dispatch('getCities', vSelectValue)
        .then(response => {
          this.cities = response
          if (this.editFirstCity) {
            this.establishment.cidade = this.cities ? this.cities[0] : null
          }
          this.editFirstCity = true
        })
        .catch((error) => {
          this.$root.$refs.notification.error(error)
        })
    },

    changeCities (vSelectValue) {
      this.establishment.cidade = vSelectValue
    },

    validate () {
      let self = this
      self.$validator.validateAll()
        .then((result) => {
          if (result && self.validateCnpj()) {
            if (self.validateAtt()) {
              self.newEstablishment()
            }
          } else {
            if (self.tabMain === self.tabAtt) {
              self.backToEstab()
            }
          }
        })
    },

    validateAtt () {
      for (const att of this.attributesList) {
        if (att.invalid) {
          return false
        }
      }
      // Retorna true caso não hajam atributos invalidos
      return true
    },

    validateCnpj () {
      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length > 0) {
        if (!customValidator.validateCnpj(this.establishment.cnpj)) {
          return false
        }
      }
      return true
    },

    backToEstab () {
      this.tabMain = this.tabEstab
    },

    nextToAtt () {
      this.tabMain = this.tabAtt
    },

    back () {
      this.$router.go(-1)
    },

    verifyCnpj () {
      if (this.establishment && this.establishment.cnpj && this.establishment.cnpj.length === 14) {
        if (!customValidator.validateCnpj(this.establishment.cnpj)) {
          this.errors.add({
            field: 'establishmentCnpjInvalid',
            msg: this.$t('estabelecimentos.erro.cnpjInvalido')
          })
        } else {
          this.errors.remove('establishmentCnpjInvalid')
        }
      } else {
        this.errors.remove('establishmentCnpjInvalid')
      }
    }
  },

  created () {
    this.loadEstablishmentAtt()
    if (!this.$store.getters.establishmentToEditId) {
      this.editFirstCity = true
      this.establishment.cidade = undefined
    } else {
      this.editFirstCity = false
    }
    this.loadEstablishmentGroups()
    this.loadUfs()
  },

  mounted () {
    let self = this
    self.$refs.ufSelect.$refs.search.addEventListener('blur', function () {
      // Timeout para garantir o callback BLUR após a DOM
      // acionar o CHANGE do valor, garantindo a verificação.
      setTimeout(() => {
        if (!self.establishment.uf) {
          self.$refs.ufSelect.search = ''
        }
      }, 100)
    })

    self.$refs.citySelect.$refs.search.addEventListener('blur', function () {
      // Timeout para garantir o callback BLUR após a DOM
      // acionar o CHANGE do valor, garantindo a verificação.
      setTimeout(() => {
        if (!self.establishment.cidade) {
          self.establishment.uf = null
          self.$refs.citySelect.search = ''
        }
      }, 100)
    })
  },

  beforeDestroy () {
    this.$store.dispatch('setHasUnsavedChanges', false)
    this.$store.dispatch('cleanEstablishmentToEdit')
  }
}

</script>

<style>
.dynamic-box {
  min-height: 380px;
}
</style>



// WEBPACK FOOTER //
// New.vue?56af82fc